<template>
  <FormSelect
    :name="name"
    @input="$emit('input', $event)"
    :value="value"
    :disabled="disabled"
    :loading="loading"
    :required="required"
    :options="containerOptions"
    :pagination="{
      enabled: true,
      searchCallback: fetchSelectableContainers,
    }"
  />
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import containersApi from '@/api/container'

export default {
  components: { FormSelect },
  props: {
    name: { type: String, required: true },
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    companyUuid: { type: String, default: null },
    selectedContainerName: { type: String, default: null }, // selected container might not be in first page of selectables
    onlyAvailableForOrders: { type: Boolean, default: false },
  },
  data: () => ({
    containerOptions: null,
    loading: true,
  }),
  methods: {
    async fetchSelectableContainers(query = null) {
      this.loading = true
      const params = { company_uuid: this.companyUuid, only_available_for_orders: true }
      if (query) params.search_phrase = query

      this.containerOptions = (await containersApi.selectableContainers(params)).containers

      if (this.selectedContainerName && !this.containerOptions.find(option => option.value === this.value)) {
        this.containerOptions.push({ label: this.selectedContainerName, value: this.value })
      }

      this.loading = false
    },
  },
  async mounted() {
    this.fetchSelectableContainers()
  },
}
</script>
